module.exports = __webpack_public_path__ + "img/01.424519fa.jpg";